import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M19.473 4.5H21.5l2 12H.5l2-12h2.278M23.5 16.5V21a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 21v-4.5M1.833 8.5h20.334" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M10.552 6.01a.5.5 0 0 1-.5.49H5.074a.5.5 0 0 1-.5-.569l.278-2a.5.5 0 0 1 .5-.431h4.742a.5.5 0 0 1 .5.51ZM13.7 6.01a.5.5 0 0 0 .5.49h4.977a.5.5 0 0 0 .5-.569l-.278-2A.5.5 0 0 0 18.9 3.5h-4.743a.5.5 0 0 0-.5.51Z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M2.5 4.5V2A1.5 1.5 0 0 1 4 .5h16A1.5 1.5 0 0 1 21.5 2v2.5M3.5 22.5v1M20.5 22.5v1M10.605 4.614h3.042" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { toRefs } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    size: { default: 12 }
  },
  setup(__props: any) {

const props = __props as { size: number }

    

    const { size } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _unref(size),
    height: _unref(size),
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, _hoisted_5, 8, _hoisted_1))
}
}

})